import { GraphDataViewModel, GroupNodeLabel } from "@features/graph/graphViewModel"
import { GraphNodeEdgeData } from "@store/services/converter/types"
import { expandGroupNode } from "@features/graph/handlers/graphGroupCollapseExpand"
import { graphNodeClickHandler } from "@features/graph/handlers/graphNodeClick"
import { zoomIdentity } from "d3"
import { getNodesBounds, getViewportForBounds } from "reactflow"
import { GraphStoreType } from "@features/graph/Graph"
import { LAG_LABEL_REGEX, getLabelWithoutLagSuffix } from "@utils/node/labelValidation"

/** @deprecated you can use native js to do it with structured clone */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
export const deepCopy = <T = any>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj))
}

export const graphSampleNodeToViewGroupNodeLabel = (node: string): GroupNodeLabel => {
  const groupNodeLabel = GraphDataViewModel.groupLabels.find((d) => d.label === node)
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  groupNodeLabel.format =
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    GraphDataViewModel.data?.nodeMap[groupNodeLabel?.key]?.display?.["Unit Format"] || ""
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  return groupNodeLabel
}

export const graphViewGroupNodeLabelToSampleNode = (label?: string): string => {
  if (!label) return ""
  if (LAG_LABEL_REGEX.test(label)) {
    const parsedLabel = convertLabel(getLabelWithoutLagSuffix(label).trim())

    if (parsedLabel.endsWith("_")) return parsedLabel.slice(0, -1)
    else return parsedLabel
  }

  return convertLabel(label.trim())
}

export const getNodeUnitById = (id: string) => {
  return GraphDataViewModel.data?.nodeMap[id]?.display?.["Unit Format"] || ""
}

export const getNodeUnitByLabel = (label: string) => {
  const nodeId = Object.entries(GraphDataViewModel.data?.labelMap || {}).find(([, value]) => {
    // support passing plain label or already "sample parsed" label
    const isExactMatch = value === label
    const isParsedLabelMatch = convertLabel(value) === label

    return isExactMatch || isParsedLabelMatch
  })?.[0]

  if (!nodeId) return ""

  return getNodeUnitById(nodeId)
}

export const graphNodeNameGetLag = (value: string | undefined): number => {
  if (!value) return 0

  let last = value.split(" ").pop()
  // there are no spaces
  if (last === value) {
    last = value.split("_").pop()
  }
  if (!last) {
    return 0
  }
  if (last.toLowerCase().startsWith("lag")) {
    return parseInt(last.substring(3))
  }
  return parseInt(last) || 0
}

export const convertLabel = (label: string): string => {
  return label
    .trimEnd()
    .replaceAll("-", "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll(" ", "_")
    .replaceAll("__", "_")
    .replaceAll("+", "and")
    .replaceAll("/", "and")
    .replace(/_+/g, "_")
}

export const graphFocusOnNode = (
  label: string,
  graphData: GraphNodeEdgeData,
  graphStore: GraphStoreType,
) => {
  4
  const entries = Object.entries(graphData.labelMap)
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  const [nodeId] = entries.filter(([_, value]) => value === label)[0]
  if (!nodeId) return
  const nodeData = graphData.nodeMap[nodeId]
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  if (nodeData.display.groups) {
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    nodeData.display.groups.forEach((groupId) => {
      const node = graphData?.groupMap[groupId]
      if (node && GraphDataViewModel.data) {
        expandGroupNode(node, GraphDataViewModel.data, graphStore)
      }
    })
  }
  graphNodeClickHandler(nodeId, graphStore)
  setTimeout(() => {
    const state = graphStore.getState()
    const node = state.nodeInternals.get(nodeId)
    if (!node || !zoomIdentity || !state.d3Selection) return
    // manual zoom - fitView somehow doesn't work
    const bounds = getNodesBounds([node])
    const viewPort = getViewportForBounds(bounds, state.width, state.height, state.minZoom, 2.5)
    const nextZoom = zoomIdentity.translate(viewPort.x, viewPort.y).scale(viewPort.zoom)
    state.d3Zoom?.transform(state.d3Selection, nextZoom)
  }, 0)
}
